import { useState, useContext, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import pick from 'lodash/pick';
import ddt from '@wix/da-ddt';
import { useThrottle } from '@wix/da-hooks/dist/src/useThrottle';
import { useDeepEqualMemo } from '@wix/da-hooks/dist/src/useDeepEqualMemo';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { makeGetPrevLoadDims } from './redux/selectors';
import { updateMeasuredCookie } from './redux/actions';
var logger = ddt.createLogger('measuredhook');
export var DEFAULT_SIZE = {
    desktop: { width: 1024, height: 768 },
    mobile: { width: 375, height: 667 },
};
var THROTTLE_TIMEOUT = 500;
var THROTTLE_OPTIONS = { trailing: true };
export function useMeasuredCookieState(cookieType, cookieDim, defaultSize, allowSSRCookie) {
    if (cookieDim === void 0) { cookieDim = 'both'; }
    if (defaultSize === void 0) { defaultSize = DEFAULT_SIZE; }
    if (allowSSRCookie === void 0) { allowSSRCookie = true; }
    var dispatch = useDispatch();
    var isMobile = useContext(MobileContext);
    var getPrevLoadDims = useRef(makeGetPrevLoadDims());
    var prevLoadDims = useSelector(function (state) {
        return cookieType !== undefined
            ? getPrevLoadDims.current(state, cookieType, cookieDim)
            : { width: 0, height: 0 };
    }, function () { return true; } // we only want to select this value once, as after mount we rely on actual measurements
    );
    var defaultSizeForPlatform = useDeepEqualMemo(isMobile ? defaultSize.mobile : defaultSize.desktop);
    var _a = useState(function () {
        return allowSSRCookie
            ? prevLoadDims && (prevLoadDims.width > 0 || prevLoadDims.height > 0)
                ? prevLoadDims
                : defaultSizeForPlatform
            : undefined;
    }), containerSize = _a[0], setContainerSize = _a[1];
    var updateContainerSize = useThrottle(function (newSize) {
        // requirement for updating the size: have the interesting measurement exist
        // and be different from what we already have
        var widthChanged = ['width', 'both'].includes(cookieDim) &&
            !!newSize.width &&
            (!containerSize || newSize.width !== containerSize.width);
        var heightChanged = ['height', 'both'].includes(cookieDim) &&
            !!newSize.height &&
            (!containerSize || newSize.height !== containerSize.height);
        if (widthChanged || heightChanged) {
            var sanitizedSize = pick(newSize, 'width', 'height');
            logger.log('Updated measurements', sanitizedSize);
            setContainerSize(sanitizedSize);
            cookieType !== undefined &&
                dispatch(updateMeasuredCookie(cookieType, cookieDim, sanitizedSize));
        }
    }, [containerSize, cookieDim, cookieType, dispatch], THROTTLE_TIMEOUT, THROTTLE_OPTIONS);
    return { containerSize: containerSize, updateContainerSize: updateContainerSize, defaultSizeForPlatform: defaultSizeForPlatform };
}
//# sourceMappingURL=useMeasuredCookieState.js.map